export default __webpack_public_path__ + "static/media/item-5-safari-14.db8f33ec.png";